module.exports = __webpack_public_path__ + "img/profile-banner.34b4c197.jpg";